import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import PendingApproval from "@/pages/PendingApproval";
import Privacy from "@/pages/Privacy";
import Preferences from "@/pages/Preferences";
import MonCompte from "@/pages/MonCompte";
import Tarifs from "@/pages/Tarifs";
import Suggestions from "@/pages/Suggestions";
import Panier from "@/pages/Panier";
import MesCommandes from "@/pages/MesCommandes";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminPending from "@/pages/admin/AdminPending";
import AdminMembers from "@/pages/admin/AdminMembers";
import AdminTarifs from "@/pages/admin/AdminTarifs";
import AdminSuggestions from "@/pages/admin/AdminSuggestions";
import AdminAnnouncement from "@/pages/admin/AdminAnnouncement";
import AdminCommandes from "@/pages/admin/AdminCommandes";
import AdminLogos from "@/pages/admin/AdminLogos";
import AdminNotifications from "@/pages/admin/AdminNotifications";
import AdminAudit from "@/pages/admin/AdminAudit";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import AnnouncementBanner from "@/components/AnnouncementBanner";
import NotFound from "@/pages/NotFound";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AnnouncementBanner />
                <Routes>
                    {/* Standalone tokenized page — no header/footer/trust bar */}
                    <Route path="/preferences" element={<Preferences />} />

                    {/* Public */}
                    <Route element={<Layout />}>
                        <Route path="/" element={<Landing />} />
                        <Route path="/connexion" element={<Login />} />
                        <Route path="/inscription" element={<Register />} />
                        <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
                        <Route path="/reinitialiser" element={<ResetPassword />} />
                        <Route path="/confidentialite" element={<Privacy />} />
                        <Route path="/en-attente" element={<PendingApproval />} />

                        {/* Protected — approved pro or admin */}
                        <Route
                            path="/tarifs"
                            element={
                                <ProtectedRoute requireApproved>
                                    <Tarifs />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/suggestions"
                            element={
                                <ProtectedRoute requireApproved>
                                    <Suggestions />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/panier"
                            element={
                                <ProtectedRoute requireApproved>
                                    <Panier />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/mes-commandes"
                            element={
                                <ProtectedRoute requireApproved>
                                    <MesCommandes />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/mon-compte"
                            element={
                                <ProtectedRoute requireApproved>
                                    <MonCompte />
                                </ProtectedRoute>
                            }
                        />
                    </Route>

                    {/* Admin */}
                    <Route
                        path="/admin"
                        element={
                            <ProtectedRoute requireAdmin>
                                <AdminLayout />
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<Navigate to="/admin/tableau-de-bord" replace />} />
                        <Route path="tableau-de-bord" element={<AdminDashboard />} />
                        <Route path="demandes" element={<AdminPending />} />
                        <Route path="membres" element={<AdminMembers />} />
                        <Route path="tarifs" element={<AdminTarifs />} />
                        <Route path="suggestions" element={<AdminSuggestions />} />
                        <Route path="commandes" element={<AdminCommandes />} />
                        <Route path="audit" element={<AdminAudit />} />
                        <Route path="flash-info" element={<AdminAnnouncement />} />
                        <Route path="logos" element={<AdminLogos />} />
                        <Route path="notifications" element={<AdminNotifications />} />
                    </Route>

                    <Route path="*" element={<NotFound />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
